import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Banner from './banner';
import HotBrand from './hotBrand';
import Atlas from './atlas';
import Ad from '@ifeng-fe/ui_pc_ad';
import NoSSR from 'react-no-ssr';

/**
 * 定义 Footer 组件
 */
class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { bottomAd, brandData, firstModuleData, atlasModuleData } = this.props.content;

        return (
            <div className={styles.contentBox}>
                <Banner firstModuleData={firstModuleData} />
                <HotBrand brandData={brandData} />
                <NoSSR onSSR={<div className={styles.box} />}>
                    <Ad content={bottomAd} styleName={styles.box} />
                </NoSSR>
                <Atlas atlasModuleData={atlasModuleData} />
            </div>
        );
    }
}

export default errorBoundary(Content);
